import PropTypes from 'prop-types';
import { isBlank } from 'utils/helperMethods';
import { head } from 'ramda';
import Presenter from 'utils/PropTypesPresenter';

export default new Presenter(
  {
    id: PropTypes.number,
    profileImageUrl: PropTypes.string,
    fullName: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    isOnline: PropTypes.bool,
  },
  {
    initials(user) {
      const fullName = this.fullName(user);
      const firstNameText = this.firstName(user);
      const lastNameText = this.lastName(user);

      if (firstNameText && lastNameText) {
        return `${head(firstNameText)}${head(lastNameText)}`;
      } else if (isBlank(fullName)) return '';
      {
        const [first, second] = this.fullName(user).split(' ');
        return `${head(first)}${head(second)}`;
      }
    },
  },
);



// WEBPACK FOOTER //
// ./src/presenters/ChatUserPresenter.js